import { Link } from "react-router-dom";
import { Compass, Users, Leaf, Sparkles } from "lucide-react";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";

const HERO = "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const layers = [
  { icon: Sparkles, title: "Holistic Recovery & Wellness", text: "The primary entry point — float, sauna, energy work, coaching, and integrative wellness." },
  { icon: Compass, title: "GAUGE Your Life", text: "The framework: Gratitude, Awareness, Unity, Growth, Energy — a compass for conscious participation." },
  { icon: Users, title: "Community Participation", text: "The development environment: groups, circles, teachings, and collaborative projects." },
  { icon: Leaf, title: "Stewardship", text: "The sustainability environment: land care, regeneration, ethical business, and planetary care." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo
        title="About Us"
        description="One living ecosystem for holistic recovery, wellness, community, and stewardship. Discover the vision, pathways, and methodology behind Enhancing Your World."
        image={HERO}
        path="/about"
      />
      <PageHero
        label="About"
        title="One living ecosystem, not a collection of tools."
        subtitle="Enhancing Your World exists to help people consciously participate in ways that benefit themselves, their relationships, their communities, humanity, future generations, and the planet."
        image={HERO}
        testid="about-hero"
      />
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-20 text-center">
        <p className="eyw-label mb-4">Our Purpose</p>
        <h2 className="font-serif text-3xl lg:text-5xl text-[#1A242B] leading-tight">
          Human enhancement means becoming more whole, present, responsible, connected, creative, grounded, and capable in how we live and relate.
        </h2>
      </section>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {layers.map((l) => (
            <div key={l.title} className="eyw-card p-7">
              <span className="grid place-items-center h-12 w-12 rounded-full bg-[#144F75]/10 text-[#144F75] mb-4"><l.icon size={22} /></span>
              <h3 className="text-lg text-[#1A242B] mb-1">{l.title}</h3>
              <p className="text-[#4A5D6B] text-sm leading-relaxed">{l.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 text-center">
          <blockquote className="font-serif text-2xl lg:text-3xl text-[#144F75] italic max-w-2xl mx-auto">
            "The organization helps bridge the gaps so each person can practice their enhancements."
          </blockquote>
          <div className="flex flex-wrap gap-4 justify-center mt-9">
            <Link to="/join" className="eyw-btn">Join Discovery</Link>
            <Link to="/gauge" className="eyw-btn-ghost">Explore GAUGE</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
